import {CellActionContext, DisplayFormatter} from './smart-table.model';
import FileSaver from 'file-saver';
import {LodashTemplateEvaluator} from './LodashTemplateEvaluator';
import {FormRendererUtils} from '../../../portal/application-forms/all-forms-renderer/form-renderer-utils';
import * as _ from 'lodash';
import {
  CustomButtonActionHandlerContext
} from "@shared/components/custom-action-button/handlers/custom-button-action-handler";
import {ActionProcessor, PopupAction} from "@shared/components/custom-action-button/custom-action-button-model";

export function attachActionHandler(displayValueFormatter: DisplayFormatter) {
  switch (displayValueFormatter.category) {
    case 'popup':
      displayValueFormatter.handler = popupActionHandler;
      break;
    case 'navigation':
      displayValueFormatter.handler = navigationActionHandler;
      break;
    case 'download':
      displayValueFormatter.handler = downloadActionHandler;
      break;
    case 'delete_row':
      displayValueFormatter.handler = deleteRowActionHandler;
      break;
    case 'edit_row':
      displayValueFormatter.handler = editRowActionHandler;
      break;
    case 'custom_event':
      displayValueFormatter.handler = customEventActionHandler;
      break;
    // Add more cases for other data types
  }
}

export function navigationActionHandler(
  cellActionContext: CellActionContext,
  displayFormatter?: DisplayFormatter
) {
  let navigationUrl = cellActionContext.actionValue;
  let stateToPropagate = {};
  if (displayFormatter?.stateToPropagateEvaluator) {
    console.log('Interpolating & Evaluating', displayFormatter);
    let scriptValue = LodashTemplateEvaluator.interpolate(
      displayFormatter?.stateToPropagateEvaluator,
      cellActionContext
    );
    stateToPropagate = FormRendererUtils.evaluate(
      scriptValue,
      cellActionContext,
      'stateToPropagate',
      true
    );

    navigationUrl = LodashTemplateEvaluator.interpolate(
      navigationUrl,
      cellActionContext.formioDataSubmission
    );

    const evaluatedNavigationUrl = FormRendererUtils.evaluate(
      navigationUrl,
      cellActionContext,
      'navigationUrl',
      true
    );
    console.log('evaluatedNavigationUrl => ', evaluatedNavigationUrl);
    if (
      !(_.isNil(evaluatedNavigationUrl) || _.isEmpty(evaluatedNavigationUrl))
    ) {
      console.log(
        'As evaluated navigationUrl is empty, using the interpolated version',
        navigationUrl
      );
      navigationUrl = evaluatedNavigationUrl;
    }
  }

  console.log('Navigating to ', navigationUrl);
  if (displayFormatter?.stateToPropagateEvaluator) {
    cellActionContext.router.navigate([navigationUrl], {
      state: { state: stateToPropagate }
    });
  } else {
    cellActionContext.router
      .navigate([navigationUrl], {
        state: { state: stateToPropagate }
      })
      .then((r) => console.log('Navigation completed from smart grid'));
  }
}

export function deleteRowActionHandler(cellActionContext: CellActionContext) {
  deleteRowData(cellActionContext);

  let key = cellActionContext.gridOptions.key;

  const eventName = `smart-table-${key}-delete_row`;
  cellActionContext.formioEvent.emit({
    eventName,
    data: {
      rowData: cellActionContext.rowData,
      key: key
    }
  });
}

export function editRowActionHandler(cellActionContext: CellActionContext) {
  emitSmartTableEvent(cellActionContext, 'edit_row');
}

export function customEventActionHandler(cellActionContext: CellActionContext) {
  emitSmartTableEvent(cellActionContext, cellActionContext.actionValue);
}

function emitSmartTableEvent(cellActionContext: CellActionContext, actionName: string) {
  const key = cellActionContext.gridOptions.key;
  const eventName = `smart-table-${key}-${actionName}`;

  const eventPayload = {
    data: {
      rowData: cellActionContext.rowData,
      key: key
    }
  };
  console.log(`Emitting event for Key -> ${eventName}  with Payload -> ${JSON.stringify(eventPayload)}`);

  cellActionContext.formioEvent.emit({
    eventName,
    data: {
      rowData: cellActionContext.rowData,
      key: key
    }
  });
}


function getValueByPath(obj: any, path: string): any {
  return path.split('.').reduce((current, key) => current?.[key], obj);
}

function deleteRowData(cellActionContext: CellActionContext) {
  const rowIndex = Number(cellActionContext.actionValue);
  const contextDataFieldName =
    cellActionContext.gridOptions.contextDataFieldName;

  if (!contextDataFieldName) {
    return;
  }

  const data = getValueByPath(
    cellActionContext.formioDataSubmission,
    contextDataFieldName
  );

  if (!Array.isArray(data)) {
    console.error(`Unable to resolve array for contextDataFieldName: ${contextDataFieldName}`);
    return;
  }

  data.splice(rowIndex, 1);
  cellActionContext.smartTableInstance.value = { data };
}

export function popupActionHandler(cellActionContext: CellActionContext,
                                   displayFormatter?: DisplayFormatter) {
  let customButtonActionHandlerContext = new CustomButtonActionHandlerContext();
  customButtonActionHandlerContext.formInstance = cellActionContext.formioInstance;
  customButtonActionHandlerContext.formInstance.rowData = cellActionContext.rowData;
  customButtonActionHandlerContext.formData = cellActionContext.rowData;
  customButtonActionHandlerContext.formioEvent = cellActionContext.formioEvent;

  let actionProcessor = new ActionProcessor();
  actionProcessor.popupAction = new PopupAction();
  actionProcessor.popupAction.inputContextVariable = 'rowData';
  actionProcessor.popupAction.popupType = 'custom';
  actionProcessor.popupAction.screenId = displayFormatter?.popupScreenId;
  customButtonActionHandlerContext.actionProcessor = actionProcessor;
  const eventName = `smart-table-${actionProcessor.popupAction.screenId}-closed`;
  cellActionContext.smartTableInstance.showPopupActionProcessor.performAction(customButtonActionHandlerContext).then(actionResult => {
    cellActionContext.formioEvent.emit({
      eventName,
      data: {
        popupResult: actionResult
      }
    });
  });
}

function downloadActionHandler(cellActionContext: CellActionContext) {
  console.log('downloadActionHandler ->', cellActionContext);
  let downloadUrl = cellActionContext.actionValue;
  console.log('downloadUrl -> ' + downloadUrl);
  FileSaver.saveAs(downloadUrl);
}
